import React from "react";
const CardBackImage = () => {
  return (
    <img src="/assets/Cards/backside.png" alt="" style={{ display: "none" }} />
  );
};

export default CardBackImage;
